import { useState, useEffect, useCallback } from 'react'
import Card from 'react-bootstrap/Card'
import './Weather.css'

const API_Key = process.env.REACT_APP_WEATHER_API_KEY;
const latitude = "18.2769"
const longitude = "73.6219"

const weatherIconMap = {
    Thunderstorm:"wi-thunderstorm",
    Drizzle: "wi-sleet",
    Rain: "wi-storm-showers",
    Clear: "wi-day-sunny",
    Clouds: "wi-cloudy",
    Default: "wi-thermometer",
};

function calculateCelsius(temp) {
    return Math.floor(temp - 273.15);
}

function calculateTime(timestamp) {
    const calcDate = new Date(timestamp * 1000)
    const calcHours = calcDate.getHours()
    const calcMinutes = "0" + calcDate.getMinutes()
    const calcSeconds = "0" + calcDate.getSeconds();
    return calcHours + ":" + calcMinutes.slice(-2) + ":" + calcSeconds.slice(-2);
}

function getWeatherIcon(rangeID) {
    switch(true){
        case rangeID>=200 && rangeID<=232:
            return weatherIconMap.Thunderstorm;
        case rangeID>=300 && rangeID<=321:
            return weatherIconMap.Drizzle;
        case rangeID>=500 && rangeID<=531:
            return weatherIconMap.Rain;
        case rangeID===800:
            return weatherIconMap.Clear;
        case rangeID>=801 && rangeID<=804:
            return weatherIconMap.Clouds;
        default:
            return weatherIconMap.Default;
    }
}

export default function Weather() {
    const [icon, setIcon] = useState(undefined);
    const [tempCelsius, setTempCelsius] = useState(undefined);
    const [maxTemp, setMaxTemp] = useState(undefined);
    const [minTemp, setMinTemp] = useState(undefined);
    const [description, setDescription] = useState("");
    const [sunrise, setSunrise] = useState(undefined);
    const [sunset, setSunset] = useState(undefined);
    const [error, setError] = useState(null);

    const getWeather = useCallback(async () => {
        try {
            const api_call = await fetch(`https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=${API_Key}`);
            if (!api_call.ok) {
                setError("Failed to fetch weather data");
                return;
            }
            const response = await api_call.json();

            setTempCelsius(calculateCelsius(response.main.temp));
            setMaxTemp(calculateCelsius(response.main.temp_max));
            setMinTemp(calculateCelsius(response.main.temp_min));
            setDescription(response.weather[0].description);
            setSunrise(calculateTime(response.sys.sunrise));
            setSunset(calculateTime(response.sys.sunset));
            setIcon(getWeatherIcon(response.weather[0].id));
        } catch (err) {
            console.error("Weather API error:", err);
            setError("Unable to load weather data");
        }
    }, []);

    useEffect(() => {
        getWeather();
    }, [getWeather]);

    if (error) {
        return(
            <div>
                <Card className="weatherCard">
                    <Card.Body>
                        <p>{error}</p>
                    </Card.Body>
                </Card>
            </div>
        );
    }

    return(
        <div>
            <Card className="weatherCard">
                <Card.Header
                    style={{"fontSize": "1.1rem"}}
                >
                    Weather at Velhe, Pune, Maharashtra <br/>
                    as of {new Date().toLocaleTimeString()}
                </Card.Header>
                <Card.Body>
                    <h5>
                        <i style={{"color": "gray", "marginTop" : "3%", "marginBottom" : "3%"}} className={`wi ${icon} display-1`}/>
                    </h5>
                    <p className="py2 boldText">{tempCelsius}&deg;C</p>
                    <p style={{"marginTop" : "1%"}}>
                        <span className="px-4 boldText">{minTemp}&deg;C</span>
                        <span className="px-4 boldText">{maxTemp}&deg;C</span>
                    </p>
                    <div>
                        <span className="px-4">Min</span>
                        <span className="px-4">Max</span>
                    </div>
                    <p style={{"marginTop" : "5%"}} className="boldText">{description.charAt(0).toLocaleUpperCase()}{description.slice(1)}</p>
                    <hr/>
                    <div>
                        <span className="px-4"> Sunrise: {sunrise}</span>
                        <span className="px-4"> Sunset: {sunset}</span>
                    </div>
                    <hr/>
                    <h6>
                        For future forecast&nbsp;
                        <a rel="noopener noreferrer" target="_blank" href="https://weather.com/weather/today/l/9c3d9dbc261b101507398dff47e63bb9830c2ba9c13282c8333bef782b6e3216">click here⇗</a>
                    </h6>
                </Card.Body>
            </Card>
        </div>
    );
}
